import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import easesCustom from "../fx/CustomEases";
import { lerp } from "../vendor/utils";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.listing = this.ref.listing[0];
    //! Vars
    this.VARS = {};
    this.VARS.ZINDEX = 1;
    this.VARS.CURRENT_SLIDE = 0;
    //! Fns

    gsap.delayedCall(Env.timingDelayFx / 1000, () => {
      this._fx();
    });
  }

  _fx() {
    this.animate();
    this.reveal();
  }

  animate() {
    this.animation = gsap.timeline();

    this.animation.add([
      gsap.fromTo(
        this.ref.header,
        {
          autoAlpha: 0,
          y: 20,
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1.2,
          ease: "cubic.out",
        }
      ),
    ]);
    for (let [i, item] of this.ref.hoverItem.entries()) {
      const timing = i == 0 ? "-=.7" : ">-.2";
      this.animation.add(
        [
          gsap.fromTo(
            item.querySelector(".text"),
            {
              y: 20,
              autoAlpha: 0,
            },
            {
              y: 0,
              autoAlpha: 1,
              ease: "cubic.out",
              duration: 0.5,
            }
          ),
          gsap.fromTo(
            item.querySelector(".separator"),
            {
              transformOrigin: "left top",
              scaleX: 0,
            },
            {
              scaleX: 1,
              ease: easesCustom.cubic,
              duration: 0.8,
            }
          ),
          gsap.fromTo(
            item.querySelector(".chevron"),
            {
              autoAlpha: 0,
            },
            {
              autoAlpha: 1,
              ease: easesCustom.cubic,
              duration: 0.8,
            }
          ),
        ],
        timing
      );
    }

    this.animation.add(
      [
        gsap.fromTo(
          this.ref.boxCta,
          {
            autoAlpha: 0,
            y: 20,
          },
          {
            autoAlpha: 1,
            y: 0,
            ease: "cubic.out",
            duration: 1,
          }
        ),
      ],
      "-=.5"
    );
  }

  reveal() {
    this.st = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: "top 50%",
    });
  }

  unmount() {
    this.st.kill(true);
  }
}
